
import Vue from 'vue';
import { TransformedCmTextMedia } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedCmTextMedia['data'],
      required: true,
    },
  },
});
